import React from 'react';
import { Input } from 'semantic-ui-react';

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const CYRILLIC_PATTERN = /[а-яёА-ЯЁ]/;

export const getEmailValidationError = (value, emptyIsValid = true) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) {
        return emptyIsValid ? null : 'Укажите адрес электронной почты';
    }
    if (/\s/.test(trimmed)) {
        return 'Адрес не должен содержать пробелы';
    }
    if (CYRILLIC_PATTERN.test(trimmed)) {
        return 'Адрес не должен содержать кириллические символы';
    }
    const atCount = (trimmed.match(/@/g) || []).length;
    if (atCount === 0) {
        return 'В адресе отсутствует символ @';
    }
    if (atCount > 1) {
        return 'В адресе допускается только один символ @';
    }
    const atIndex = trimmed.indexOf('@');
    const localPart = trimmed.slice(0, atIndex);
    const domainPart = trimmed.slice(atIndex + 1);
    if (!localPart) {
        return 'Укажите имя до символа @';
    }
    if (!domainPart) {
        return 'Укажите домен после символа @';
    }
    if (!domainPart.includes('.')) {
        return 'Укажите домен с точкой (например, mail.ru)';
    }
    const domainLabels = domainPart.split('.').filter(Boolean);
    if (domainLabels.length < 2 || domainLabels.some((label) => label.length === 0)) {
        return 'Некорректный формат домена';
    }
    if (!EMAIL_PATTERN.test(trimmed)) {
        return 'Некорректный формат адреса электронной почты';
    }
    return null;
};

const SemanticEmailInput = ({ value, onChange, onBlur, placeholder, ...otherProps }) => (
    <Input
        type="text"
        autoComplete="email"
        spellCheck={false}
        placeholder={placeholder || ''}
        value={value || ''}
        maxLength={254}
        onChange={onChange}
        onBlur={onBlur}
        {...otherProps}
    />
);

export default SemanticEmailInput;



// WEBPACK FOOTER //
// ./App/controls/semanticEmailInput.jsx